import React from "react";
import { useForm } from "react-hook-form";
// import { getUser } from "@/lib/api/authentication";

// import { updateSkillCategoryAbout } from "@/lib/api/api";
import { useToast } from "@/components/ui/use-toast";
import { getUserInfo } from "@/lib/api/client-authentication";



type AboutFormSubmit = {
	hour: string;
	halfAnHour: string;
	currency: string;
	about?: string;
};

type FormProps = {
	id: string;
	onUpdate: (id: string, about: any) => Promise<void>;
	aboutDetails: any;
};

export const AboutForm = ({ id, onUpdate, aboutDetails }: FormProps) => {
	const {
		register,
		handleSubmit,
		reset,
		formState: { errors, isSubmitting },
	} = useForm<AboutFormSubmit>({
		defaultValues: {
			hour: aboutDetails?.hour,
			halfAnHour: aboutDetails?.halfAnHour,
			currency: aboutDetails?.currency_code,
			about: aboutDetails?.about,
		},
	});
	const { toast } = useToast()

	const resetForm = () => {
		reset();
	};

	const onSubmit = async (data: AboutFormSubmit) => {

		const about = {
			about: data["about"],
			currency_code: data["currency"],
			halfAnHour: data["halfAnHour"],
			hour: data["hour"],
		};

		let result

		console.log("ABOUT DATA AFTER PARSED ", about)
		console.log("ABOUT DATA RECIEVED", data)
		result = await onUpdate(id, about)


		// const result = await toast.promise(
		// 	updateSkillCategoryAbout(user.attributes.sub, id, about),
		// 	{
		// 		pending: {
		// 			render() {
		// 				return "Saving...";
		// 			},
		// 			icon: false,
		// 		},
		// 		success: {
		// 			render({ data }) {
		// 				return `Success`;
		// 			},
		// 			// other options
		// 			icon: "🟢",
		// 		},
		// 		error: {
		// 			render({ data }) {
		// 				// When the promise reject, data will contains the error
		// 			},
		// 		},
		// 	}
		// );



	};
	console.log("-----HERE IN ABOUT")
	return (
		<div className="profile-add">
			<div className="row">
				<div className="col-md-10 offset-sm-1">
					<h1 className="text-lg font-bold underline">About Your Skill </h1>
					<br />
					<form>
						<div className="form-row mb-2">
							<div className="flex flex-col">
								<label className="text-base font-bold">About :</label>
								<textarea
									{...register("about", { required: true })}
									className={`text-base border-black border  border-solid rounded-sm pl-1 ${errors.about ? "is-invalid" : ""
										}`}
									name="about"

								/>
							</div>
						</div>
						<div className="form-row mb-2">
							<div className="flex flex-col">
								<label className="text-base font-bold">Currency Code :</label>
								<input
									{...register("currency", { required: true })}
									className={`text-base border-black border border-solid rounded-sm pl-1 ${errors.currency ? "is-invalid" : ""
										}`}
									name="currency"
									maxLength={4}
								/>
							</div>
						</div>
						<div className="form-row mb-2">
							<div className="flex flex-col">
								<label className="text-base font-bold">Rate per hour :</label>
								<input
									{...register("hour", { required: true })}
									className={`text-base border-black border  border-solid rounded-sm pl-1 ${errors.hour ? "is-invalid" : ""
										}`}
									name="hour"
									type="number"
								/>
							</div>
						</div>
						<div className="form-row mb-2">
							<div className="flex flex-col">
								<label className="text-base font-bold">Rate per half an hour :</label>
								<input
									{...register("halfAnHour", { required: true })}
									className={`text-base border-black border  border-solid rounded-sm pl-1 ${errors.halfAnHour ? "is-invalid" : ""
										}`}
									name="halfAnHour"
									type="number"
								/>
							</div>
						</div>
						<br />
						<div className="form-row">
							<div className="col-md-12 text-center">
								<button
									type="submit"
									onClick={handleSubmit(onSubmit)}
									className="btn btn-primary btn-save">
									Submit
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
};
